import axios from "axios";

const api = axios.create({
  baseURL: "https://mdm.familytogetherkap.uk"
});

export default api;
